const TextAreaComponent = {
    templateUrl: '/formViewer/component/textarea/textArea.tpl.html',
    controller: 'textAreaController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiTextArea', TextAreaComponent);
